import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, uniqueId } from 'lodash';
import filesize from "filesize";
import axios from "axios";
import { i18n } from '../../../../translate/i18n';
import {
  Paper,
  Typography,
  FormControl,
  IconButton,
  Container,
  TextField,
  Button,
  Divider,
  Avatar,
  useMediaQuery,
  Box,
  Chip
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import * as actions from "../../../../store/actions";
import FileDownloadButton from '../../../../components/FileDownloadButton/FileDownloadButton';
import API from '../../../../axios/api';
import Tabs from '../../../../components/Tabs/TabsEquipment';
import checkTenantFeatureFlag, { VIEW_MAINTENANCE } from '../../../../utils/checkTenantFeatureFlag';

import {
  FormStyled,
  DoneIconStyled,
  DivSubmitButtons,
  DivFormTitle,
} from './../styles';

import confirm from '../../../../UI/Confirm/confirm';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import ModalEditPhoto from '../../../../UI/PhotoEditor/ModalEditor';
import PhotoUpload from '../../../../UI/PhotoUpload';
import PhotoBarUploading from '../../../../UI/PhotoBarUploading/PhotoBarUploading';
import Spinner from '../../../../components/Spinner/index';
import SiteSelector from '../../../../UI/SiteSelector/SiteSelector';
import FormEquipmentsServiceTypes from './FormEquipmentsServiceTypes';
import EquipmentStatusButtons from '../../../../components/EquipmentStatusButton/index';
import EquipmamentChangeStatusInput from '../../../../components/EquipmentChangeStatusInput/index';
import { EquipmentsRegistrationLimitWarning } from '../../../../components/EquipmentsRegistrationLimitWarning';
import { EAccessRole } from '../../../../store/types';
import EFeatureFlags from '../../../../utils/EFeatureFlags';

const FormEquipments = (props) => {
  const equipId = props.match.params.id
  const backPage = props.match.params.back_page;
  const backPageId = props.match.params.back_page_id;
  const placeId = equipId === 'new' && backPage === 'admin-equip-places' && backPageId ? backPageId : null;

  const dispatch = useDispatch();
  const matches = useMediaQuery('(min-width:1200px)');

  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(true);
  const [serialNumber, setSerialNumber] = useState('')
  const [showActiveCommentInput, setShowActiveCommentInput] = useState(false);
  const [activeComment, setActiveComment] = useState('');
  const [showMaintenanceCommentInput, setShowMaintenanceCommentInput] = useState(false);
  const [maintenanceComment,setMaintenanceComment] = useState('');

  // parametros para busca do autocomplete
  const page = 1;
  const limit = 50;
  const orderBy = 'name';
  const order = 'asc';

  // forms equipments
  const [profile, setProfile] = useState([])
  const [brand, setBrand] = useState('')
  const [description, setDescription] = useState('')
  const [reference, setReference] = useState('')
  const [manufacturingDate, setManufacturingDate] = useState(null)

  const [active, setActive] = useState(true)
  const [maintenance, setMaintenance] = useState(false);

  const [modalPhoto, setModalPhoto] = useState();
  const [openModalAvatar, setOpenModalAvatar] = useState(false);

  // error forms
  const [areaError, setAreaError] = useState(false);
  const [companyError, setCompanyError] = useState(false);
  const [brandError, setBrandError] = useState(false);
  const [serialNumberError, setSerialNumberError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [referenceError, setReferenceError] = useState(false);
  const [manufacturingDateError, setManufacturingDateError] = useState(false);
  const [placesError, setPlacesError] = useState(false);
  const [equipmentModelsError, setEquipmentModelsError] = useState(false);
  const [profileError, setProfileError] = useState(false);

  // selected values on autocomplete
  const [selectedAreas, setSelectedAreas] = React.useState({ value: "", label: ""});
  const [selectedCompanies, setSelectedCompanies] = React.useState([]);
  const [selectedPlaces, setSelectedPlaces] = React.useState({ value: "", label: "", site: ""});
  const [selectedEquipmentModels, setSelectedEquipmentModels] = React.useState({ value: "", label: ""});

  const [searchTextAreas, setSearchTextAreas] = useState("")
  const [searchTextCompanies, setSearchTextCompanies] = useState("")
  const [searchTextPlaces, setSearchTextPlaces] = useState("")
  const [searchTextEquipmentModels, setSearchTextEquipmentModels] = useState("")

  const [placesFormated, setPlacesFormated] = useState([])
  const [equipmentModelsFormated, setEquipmentModelsFormated] = useState([])
  const [areasFormated, setAreasFormated] = useState([])
  const [companiesFormated, setCompaniesFormated] = useState([])

  const [sendForMaintenance, setSendForMaintenance] = useState(null);
  const [sendForInactivate, setSendForInactivate] = useState(null);

  const selectSite = useCallback(
    (site) => dispatch(actions.selectSitePlaces(site))
  );

  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  const tenantFeatureFlags = useSelector(state => state.auth.selectedAccess.tenant.tenantFeatureFlags);
  const {
    area: areaFieldIsMandatory,
    company: companyFieldIsMandatory,
    reference: referenceFieldIsMandatory,
    serialNumber: serialNumberFieldIsMandatory,
    brand: brandFieldIsMandatory,
    description: descriptionFieldIsMandatory,
    manufacturingDate: manufacturingDateFieldIsMandatory,
  } = selectedAccess.tenant.equipmentFormMandatoryFields;
  const isAdmin = selectedAccess.role === EAccessRole.admin;
  const isAnalyst = selectedAccess.role === EAccessRole.analyst;
  const isContractor = selectedAccess.role === EAccessRole.contractor;
  const isInspector = selectedAccess.inspector && (isAnalyst || isContractor);

  const onlyQRServicesFeatureFlag = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING);
  const blockQrCodePrinting = (onlyQRServicesFeatureFlag && (isAnalyst || isContractor));
  const blockEquipCreationInSitesWithoutAccess = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_EQUIPMENT_CREATION_IN_SITES_WITHOUT_ACCESS);

  const deleteEquipments = () => dispatch(actions.deleteEquipments(props.match.params.id));
  const revertdeletedEquipments = () => dispatch(actions.revertdeletedEquipments(props.match.params.id))

  // fetch from BE
  const fetchCompanies = useCallback(
    () => dispatch(actions.equipmentsFetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
    [page, limit, searchTextCompanies, order, orderBy]
  );
  const fetchAreas = useCallback(
    () => dispatch(actions.fetchAreas(page, limit, searchTextAreas, order, orderBy)),
    [page, limit, searchTextAreas, order, orderBy]
  );
  const fetchPlacesLeafs = useCallback(
    () => dispatch(actions.equipmentsFetchPlacesLeafs(selectedSites)),
    [selectedSites]
  );
  const fetchEquipmentModels = useCallback(
    () => dispatch(actions.equipmentsFetchEquipmentModels(page, limit, searchTextEquipmentModels, order, orderBy)),
    [page, limit, searchTextEquipmentModels, order, orderBy]
  );

  const fetchEquipment = useCallback(
    () => dispatch(actions.fetchEquipmentsById(equipId))
  );
  const fetchPlace = useCallback(
    () => dispatch(actions.equipmentsFetchPlacesById(placeId))
  );

  // get from redux
  const place = useSelector(state => state.equipments.place);
  const places = useSelector(state => state.equipments.placesLeafs);
  const equipmentModels = useSelector(state => state.equipments.equipmentModels)
  const equipmentModel = useSelector(state => state.equipments.equipmentModel)

  const equipment = useSelector(state => state.equipments.equipment);
  const companies = useSelector(state => state.equipments.companies);
  const areas = useSelector(state => state.areas.areas);

  const loadingAreas = useSelector(state => state.areas.loading);
  const loadingCompanies = useSelector(state => state.equipments.companiesLoading);
  const loadingPlaces = useSelector(state => state.equipments.placesLoading);
  const loadingEquipmentModels = useSelector(state => state.equipments.equipmentModelsLoading);
  const loadingEquipments = useSelector(state => state.equipments.loading);

  // FUNCTION TO FORMAT TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = areas
    let returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setAreasFormated(returnArray)
  }, [areas]);

  useEffect(() => {
    const dataFromRedux = companies
    let returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setCompaniesFormated(returnArray)
  }, [companies]);

  useEffect(() => {
    const dataFromRedux = places
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: `${dt.name} - (${dt.path})`, site: dt.site }))

    const shouldBlockSitesWithoutAccess = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_EQUIPMENT_CREATION_IN_SITES_WITHOUT_ACCESS);
    if (shouldBlockSitesWithoutAccess) {
      const accessibleSiteIds = selectedAccess.sites.map(site => site._id);
      setPlacesFormated(returnArray.filter(place => accessibleSiteIds.includes(place.site)))
    } else {
      setPlacesFormated(returnArray)
    }
  }, [places]);

  useEffect(() => {
    const dataFromRedux = equipmentModels
    const returnArray = []
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setEquipmentModelsFormated(returnArray)
  }, [equipmentModels])

  useEffect(() => {
    const placeFormated = {
      value: place._id,
      label: `${place.name} - (${place.path})`,
      site: place.site,
    }
    setSelectedPlaces(placeFormated)
  }, [place])

  useEffect(() => {
    fetchAreas(page, limit, searchTextAreas, order, orderBy);
  }, [searchTextAreas]);

  useEffect(() => {
    if (selectedAccess.role !== 'contractor') fetchCompanies(page, limit, searchTextCompanies, order, orderBy);
  }, [searchTextCompanies]);

  useEffect(() => {
    fetchPlacesLeafs(page, limit, searchTextPlaces, order, orderBy);
  }, [searchTextPlaces, selectedSites]);

  useEffect(() => {
    fetchEquipmentModels(page, limit, searchTextEquipmentModels, order, orderBy);
  }, [searchTextEquipmentModels]);


  // check if is newEntrance or editing
  useEffect(() => {
    setIsNewData(equipId && equipId === 'new')

    if (equipId && equipId !== 'new') {
      fetchEquipment()
    } else if (placeId) {
      fetchPlace();
      dispatch(actions.clearEquipmentsEquipmentModelsById())
    } else {
      setSelectedPlaces({ value: "", label: "", site: ""})
      setSelectedEquipmentModels({ value: "", label: ""})
      setSelectedAreas({ value: "", label: ""})
      setSelectedCompanies([])
      dispatch(actions.clearEquipmentsEquipmentModelsById())
    }
  }, [])

  // in case editing, populate fields
  useEffect(() => {
    if (!isEmpty(equipment) && equipId && equipId !== 'new') {
      const profileArray = []
      profileArray.push(equipment.photo);
      setActive(equipment.active);
      setMaintenance(equipment.maintenance);
      setProfile(profileArray)
      setBrand(equipment.brand);
      setDescription(equipment.description)
      setSerialNumber(equipment.serialNumber ? equipment.serialNumber : '')
      setReference(equipment.reference ? equipment.reference : '')
      setManufacturingDate(equipment.manufacturingDate ? equipment.manufacturingDate : null)
      setSendForMaintenance(!equipment.maintenance);
      setSendForInactivate(equipment.active);

      let area = {}
      if (!isEmpty(equipment.area)) {
        area = { value: equipment.area._id, label: equipment.area.name }
      }
      setSelectedAreas(area)

      setSelectedCompanies(equipment.companies?.map((company) => ({ value: company._id, label: company.name})) || [{ value: equipment.company._id, label: equipment.company.name }])

      let place = {}
      place = { value: equipment.place._id, label: `${equipment.place.name} - (${equipment.place.path})`, site: equipment.site }
      setSelectedPlaces(place)

      let equipmentModel = {}
      equipmentModel = { value: equipment.equipmentModel._id, label: equipment.equipmentModel.name }
      setSelectedEquipmentModels(equipmentModel)

    }
  }, [equipment])


  // send data to Server (post and update)
  const postEquipments = (body) => dispatch(actions.postEquipments(body))
  const updateEquipments = (body, message = '') => dispatch(actions.updateEquipments(equipId, body, message))

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (!selectedPlaces || selectedPlaces?.value === "") {
      setPlacesError(true);
      hasError = true
    }

    if (!selectedEquipmentModels || selectedEquipmentModels?.value === "") {
      setEquipmentModelsError(true);
      hasError = true
    }

    if (areaFieldIsMandatory && (!selectedAreas || selectedAreas?.value === "")) {
      setAreaError(true);
      hasError = true;
    }

    if (selectedAccess.role !== 'contractor' && companyFieldIsMandatory && isEmpty(selectedCompanies)) {
      setCompanyError(true);
      hasError = true;
    }

    if (brandFieldIsMandatory && brand === '') {
      setBrandError(true);
      hasError = true;
    }

    if (manufacturingDateFieldIsMandatory && !manufacturingDate) {
      setManufacturingDateError(true);
      hasError = true;
    }

    if (serialNumberFieldIsMandatory && serialNumber === '') {
      setSerialNumberError(true);
      hasError = true;
    }

    if (descriptionFieldIsMandatory && description === '') {
      setDescriptionError(true);
      hasError = true;
    }

    if (referenceFieldIsMandatory && reference === '') {
      setReferenceError(true);
      hasError = true;
    }

    // To check is has a invalid deadline
    if (isNewData) {
      if (equipmentModel && equipmentModel.equipmentServices && equipmentModel.equipmentServices.length > 0) {
        equipmentModel.equipmentServices.forEach(service => {
          if (service.expiration && !service.isValid) {
            hasError = true;
          }
        })
      }
    }

    if (profile.length > 0 && profile[0]) {
      const notUploaded = profile.filter(fl => fl.uploaded === false)
      if (notUploaded.length > 0) {
        setProfileError(true)
        hasError = true;
      }
    }

    if (hasError) return;

    const body = {
      site: selectedPlaces.site,
      "active": active,
      "maintenance": maintenance,
      "place": selectedPlaces.value,
      "equipmentModel": selectedEquipmentModels.value,
      "brand": brand,
      "description": description,
      "serialNumber": serialNumber,
      "reference": reference,
      "manufacturingDate": manufacturingDate,
      companies: !(selectedAccess.role === 'contractor' && isNewData) ? selectedCompanies.map((company) => company.value) : [selectedAccess.company._id],
      company: !(selectedAccess.role === 'contractor' && isNewData) ? selectedCompanies[0]?.value || null : selectedAccess.company._id,
      area: (selectedAreas && selectedAreas.value !== "") ? selectedAreas.value : null,
    }

    if (profile.length > 0 && profile[0] && (profile[0].id || profile[0]._id)) {
      body.photo = profile[0].id ? profile[0].id : profile[0]._id
    }
    
    
    if (isNewData || placeId) {
      // payload para servicos ja feitos
      const equipServices = []
      if (equipmentModel && equipmentModel.equipmentServices.length > 0) {
        equipmentModel.equipmentServices.forEach(service => {
          if (service.expiration) {
            equipServices.push({
              equipmentServiceId: service._id,
              expiration: service.expiration,
            })
          }
        })
      }
      body.services = equipServices
      postEquipments(body).then(result => {
        if (result === 'success') {
          dispatch(actions.setDataChangedForceReload(true))
          props.history.goBack()
        }
      })
    } else {
      updateEquipments(body).then(result => {
        if (result === 'success') {
          dispatch(actions.setDataChangedForceReload(true))
          setEditMode(false)
        }
      })
    }
  }


  const handleDeleteEquipment = (equipName) => {
    confirm(`${i18n.t('handleDeleteEquipment.confirm1')} ${equipName}? \n ${i18n.t('handleDeleteEquipment.confirm2')}`,
      {
        title: i18n.t('handleDeleteEquipment.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteEquipments().then(() => {
            dispatch(actions.setDataChangedForceReload(true))
            props.history.push(`/${backPage}${backPageId ? `/${backPageId}` : ''}`);
          })
        },
      )
  }

  const handleRestoreDeletedEquipment = async (equipName) => {
    confirm(`${i18n.t('formRestoreEquipment.text')} ${equipName}? \n ${i18n.t('formRestoreEquipment.text2')}`,
      {
        title: i18n.t('formRestoreEquipment.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          revertdeletedEquipments().then(() => {
            dispatch(actions.setDataChangedForceReload(true))
            props.history.push(`/${backPage}${backPageId ? `/${backPageId}` : ''}`);
          });
        },
      )
    
  }

  const handleClose = () => {
    const profileArray = []
    profileArray.push(equipment.photo);
    setActive(equipment.active);
    setMaintenance(equipment.maintenance);
    setProfile(profileArray)
    setBrand(equipment.brand);
    setDescription(equipment.description)
    setSerialNumber(equipment.serialNumber ? equipment.serialNumber : '')
    setReference(equipment.reference ? equipment.reference : '')

    let area = {}
    if (!isEmpty(equipment.area)) {
      area = { value: equipment.area._id, label: equipment.area.name }
    }
    setSelectedAreas(area)

    setSelectedCompanies(equipment.companies?.map((company) => ({ value: company._id, label: company.name})) || [{ value: equipment.company._id, label: equipment.company.name }])

    let place = {}
    place = { value: equipment.place._id, label: `${equipment.place.name} - (${equipment.place.path})`, site: equipment.site }
    setSelectedPlaces(place)

    let equipmentModel = {}
    equipmentModel = { value: equipment.equipmentModel._id, label: equipment.equipmentModel.name }
    setSelectedEquipmentModels(equipmentModel)

    setEditMode(false);
  }

  const handleInputChangeSelectorPlaces = (text) => {
    setSearchTextPlaces(text);
  }

  const handleInputChangeSelectorEquipmentModels = (text) => {
    setSearchTextEquipmentModels(text);
  }

  const handleInputChangeSelectorAreas = (text) => {
    setSearchTextAreas(text);
  }

  const handleInputChangeSelectorCompanies = (text) => {
    setSearchTextCompanies(text);
  }

  const handleInputChangePlaces = selected => {
    setPlacesError(false);
    setSelectedPlaces(selected)
  }

  const handleInputChangeEquipmentModels = selected => {
    setEquipmentModelsError(false);
    setSelectedEquipmentModels(selected)
    if (selected) {
      dispatch(actions.equipmentsFetchEquipmentModelsById(selected.value))
    } else {
      dispatch(actions.clearEquipmentsEquipmentModelsById())
    }
  }

  const handleInputChangeAreas = selected => {
    setAreaError(false);
    setSelectedAreas(selected)
  }

  const handleInputChangeCompanies = selected => {
    setSelectedCompanies(selected||[])
    setCompanyError(false);
  }

  const handleUploadPhoto = photo => {
    const uploadingFiles = photo.map(file => ({
      file,
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      fileType: file.type,
      uploaded: false,
      error: false,
      url: null
    }))

    // setProfile(uploadingFiles)
    // uploadingFiles.forEach(processUpload);
    setModalPhoto(uploadingFiles[0]);
    setOpenModalAvatar(true);

  }

  const handleCloseModalAvatar = (file) => {
    const uploadedFile = [];
    if (file) {
      uploadedFile.push({
        file,
        _id: uniqueId(),
        name: file.name,
        readableSize: filesize(file.size),
        preview: URL.createObjectURL(file),
        fileType: file.type,
        uploaded: false,
        error: false,
        url: null
      });
      setProfile(uploadedFile)
      processUpload(uploadedFile[0])
    }
    setOpenModalAvatar(false);
  }

  const updateFile = (id, data) => {
    setProfile(prevUf => {
      return prevUf.map(uf => id === uf._id ? { ...uf, ...data } : uf)
    })
  };


  const processUpload = async uploadedFile => {

    const payloadToSign = {
      fileType: uploadedFile.fileType,
      name: uploadedFile.name
    };

    API.post("photos/signurl", { file: payloadToSign }).then(signUrlRes => {
      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile._id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `profile/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType,
          source: 'web',
        }

        API.post("photos", body)
          .then(response => {
            setProfileError(false);
            updateFile(uploadedFile._id, {
              uploaded: true,
              _id: response.data._id,
              url: response.data.url
            });
          })
          .catch(() => {
            updateFile(uploadedFile._id, {
              error: true
            });
          });
      })
    })
  }


  const handleShowActiveComment = () => {
    setShowActiveCommentInput(true);
  }

  const handleCloseActiveComment = () => {
    setShowActiveCommentInput(false);
  }

  const handleShowMaintenanceComment = () => {
    setShowMaintenanceCommentInput(true);
  }

  const handleCloseMaintenanceComment = () => {
    setShowMaintenanceCommentInput(false);
  }


  const handleActiveButton = () => {
    handleShowActiveComment();
  };

  const handleSaveActiveStatus = () => {
    const newActive = !active; // to invert the value
    let hasError = false;
    handleCloseActiveComment();
    setActive(newActive);
    if (isEmpty(selectedPlaces)) {
        setPlacesError(true);
      hasError = true
    }
    if (isEmpty(selectedEquipmentModels)) {
        setEquipmentModelsError(true);
      hasError = true
    }

    // To check is has a invalid deadline
    if (isNewData) {
      if (equipmentModel && equipmentModel.equipmentServices.length > 0) {
        equipmentModel.equipmentServices.forEach(service => {
          if (service.expiration && !service.isValid) {
            hasError = true;
          }
          })
      }
    }

    if (profile.length > 0 && profile[0]) {
      const notUploaded = profile.filter(fl => fl.uploaded === false)
      if (notUploaded.length > 0) {
        setProfileError(true)
          hasError = true;
      }
      }

    if (hasError) return

    const body = {
      comment: activeComment,
      ids: [equipId],
      sendForInactivate,
    }

    try {        
      dispatch(actions.inactivateEquipments(body));
      setActiveComment('');
      setSendForInactivate(!sendForInactivate);
      dispatch(actions.setDataChangedForceReload(true))
      setEditMode(false)
    } catch(err) {
      setActiveComment('');
    }
  };

  const handleMaintenanceButton = () => {
    handleShowMaintenanceComment();
  };

  const handleSaveMaintenanceStatus = () => {
    const newMaintenanceStatus = !maintenance; // to invert the value
    handleCloseMaintenanceComment();
    let hasError = false;
    setMaintenance(newMaintenanceStatus);

    if (isEmpty(selectedPlaces)) {
      setPlacesError(true);
      hasError = true
    }

    if (isEmpty(selectedEquipmentModels)) {
      setEquipmentModelsError(true);
      hasError = true
    }

    // To check is has a invalid deadline
    if (isNewData) {
      if (equipmentModel && equipmentModel.equipmentServices.length > 0) {
        equipmentModel.equipmentServices.forEach(service => {
          if (service.expiration && !service.isValid) {
            hasError = true;
          }
        })
      }
    }

    if (profile.length > 0 && profile[0]) {
      const notUploaded = profile.filter(fl => fl.uploaded === false)
      if (notUploaded.length > 0) {
        setProfileError(true)
        hasError = true;
      }
    }

    if (hasError) return

      const body = {
        comment: maintenanceComment,
        ids: [equipId],
        sendForMaintenance,
      }

      try {        
        dispatch(actions.maintenanceEquipments(body))
        setMaintenanceComment('');
        setSendForMaintenance(!sendForMaintenance);
        dispatch(actions.setDataChangedForceReload(true))
        setEditMode(false)
      } catch(err) {
        setMaintenanceComment('');
      }
          
  };




  const tenant = useSelector((state) => state.auth.selectedAccess.tenant);
  const registeredEquipments = useSelector((state) => state.tenants.registeredEquipments);
  
  const equipmentsRegistrationLimit = tenant?.equipmentsRegistrationLimit;
    
  if (isNewData && equipmentsRegistrationLimit && equipmentsRegistrationLimit.maxEquipments > 0 && registeredEquipments >= 0) {
    const {
      maxEquipmentsTolerated = 0,
      maxEquipments = 0,
      tolerance = 0
    } = equipmentsRegistrationLimit;

    if (registeredEquipments >= maxEquipmentsTolerated) {
      return (
        <EquipmentsRegistrationLimitWarning version="form" />
      )
    }
  }

  return <>
    {!loadingEquipments && showActiveCommentInput &&
      <EquipmamentChangeStatusInput
        setContent={setActiveComment}
        handleSave={handleSaveActiveStatus}
        closeModal={handleCloseActiveComment}
        title={`${active ? i18n.t('equipmentChangeStatusInput.activeTitleTrue') : i18n.t('equipmentChangeStatusInput.activeTitleFalse')} ${i18n.t('equipmentChangeStatusInput.activeTitle')}`}
        type={`${active ? 'inactivate' : 'reactivate'}`}
      />}

    {!loadingEquipments && showMaintenanceCommentInput &&
      <EquipmamentChangeStatusInput
        setContent={setMaintenanceComment}
        handleSave={handleSaveMaintenanceStatus}
        closeModal={handleCloseMaintenanceComment}
        title={`${maintenance ? i18n.t('equipmentChangeStatusInput.maintenanceTitleTrue') : i18n.t('equipmentChangeStatusInput.maintenanceTitleFalse')} ${i18n.t('equipmentChangeStatusInput.maintenanceTitle')}`}
        type={`${maintenance ? 'return-maintenance' : 'maintenance'}`}
      />}
    
    {isNewData && <EquipmentsRegistrationLimitWarning version="form" />}
    <Tabs {...props} selected={'equipmentTab'} showLogs={isAdmin} />
    <ModalEditPhoto
      selectedFile={modalPhoto}
      open={openModalAvatar}
      onClose={handleCloseModalAvatar}
      title={i18n.t('modalEditPhotoFormEquip.title')}
    />
    <div style={matches ? styles.divContainer : styles.divContainerSmall}>
      <Container maxWidth='md' style={styles.container}>
        { !isNewData && <>
          {
            selectedAccess.role === 'admin' && equipment.deleted ?
            <Button variant='contained' style={styles.restoreButton} onClick={() => handleRestoreDeletedEquipment(selectedEquipmentModels.label)}>{i18n.t('formRestoreEquipment.buttonText')}</Button>
            : !isInspector && <EquipmentStatusButtons active={active} maintenance={maintenance} handleMaintenance={handleMaintenanceButton} handleActiveButton={handleActiveButton} maintenanceFeatureFlag={checkTenantFeatureFlag(VIEW_MAINTENANCE, tenantFeatureFlags)} />
          }
          </>
        }
        {loadingEquipments && <Spinner overlay />}
        <Paper>
          <FormStyled onSubmit={handleSubmit} style={{ opacity: loadingEquipments ? '0.3' : '1' }}>
            <DivFormTitle>
              <Typography variant='h6'>{equipId === 'new' || placeId ? i18n.t('divFormTitle.typographyTrue') : i18n.t('divFormTitle.typographyFalse')}</Typography>
              {!isNewData && !placeId &&
                <DivSubmitButtons>
                  {editMode ?
                    <>
                      <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                      <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                    </> :
                    <>
                      <IconButton disabled={isInspector} onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                      <IconButton
                        onClick={() => handleDeleteEquipment(selectedEquipmentModels.label)}
                        size="large"
                        disabled={isInspector}
                      >
                          <DeleteIcon />
                      </IconButton>
                    </>}
                </DivSubmitButtons>}
            </DivFormTitle>
            <Divider />
            <>
              <div style={styles.photoQRContainer}>
                <div style={styles.photoContainer}>
                  {!editMode && !isNewData && !placeId && profile && !profile[0] ?
                    <Avatar style={styles.avatar}>{i18n.t('avatarFormEquip.photo')}</Avatar>
                    : (<>
                      <PhotoUpload onUpload={handleUploadPhoto} photo={loadingEquipments ? [] : profile} enabled={editMode || isNewData || placeId} />
                      <PhotoBarUploading photo={profile} />
                      {profileError ? <Typography style={{ color: "#f44336" }}>{i18n.t('photoBarUploadingFormEquip.typography')}</Typography> : null}
                    </>)}
                </div>
                {!isNewData && !placeId &&
                  <div>
                    {!blockQrCodePrinting && <FileDownloadButton type="small_qrcode" documentId={equipId} />}
                  </div>}
              </div>

              {isNewData &&
                <SiteSelector
                  selectedSites={selectedSites}
                  selectSite={(site) => selectSite(site)}
                  allowedSites={blockEquipCreationInSitesWithoutAccess ? selectedAccess.sites : null}
                />
              }

              <FormControl variant="standard" fullWidth margin='normal'>
                <Autocomplete
                  loading={loadingPlaces} // sent to isLoading
                  label={i18n.t('autocompleteFormEquip.local')}
                  data={placesFormated} // sent to options
                  onSelectValue={handleInputChangePlaces} // sent to onChange
                  valueSelected={selectedPlaces} // sent to value
                  newSearchText={handleInputChangeSelectorPlaces}
                  name='place'
                  hasError={placesError}
                  disabled={(!isNewData && !editMode) || !!placeId}
                />
              </FormControl>

              <FormControl variant="standard" fullWidth margin='normal'>
                <Autocomplete
                  loading={loadingEquipmentModels} // sent to isLoading
                  label={i18n.t('autocompleteFormEquip.equipment')}
                  data={equipmentModelsFormated} // sent to options
                  onSelectValue={handleInputChangeEquipmentModels} // sent to onChange
                  valueSelected={selectedEquipmentModels} // sent to value
                  newSearchText={handleInputChangeSelectorEquipmentModels}
                  name='equipment'
                  hasError={equipmentModelsError}
                  disabled={!isNewData}
                />
              </FormControl>

              {(isNewData || placeId) && (selectedEquipmentModels && selectedEquipmentModels.value !== "") && <FormEquipmentsServiceTypes />}

              <FormControl variant="standard" fullWidth margin='normal'>
                <Autocomplete
                  loading={loadingAreas} // sent to isLoading
                  label={i18n.t('autocompleteFormEquip.area')}
                  data={areasFormated} // sent to options
                  onSelectValue={handleInputChangeAreas} // sent to onChange
                  valueSelected={selectedAreas} // sent to value
                  newSearchText={handleInputChangeSelectorAreas}
                  name='area'
                  disabled={!isNewData && !editMode && !placeId}
                  hasError={areaError}
                />
              </FormControl>
              {(selectedAccess.role !== 'contractor') && <FormControl variant="standard" fullWidth margin='normal'>
                  <Autocomplete
                    loading={loadingCompanies} // sent to isLoading
                    label={i18n.t('autocompleteFormEquip.company')}
                    data={companiesFormated} // sent to options
                    onSelectValue={handleInputChangeCompanies} // sent to onChange
                    valueSelected={selectedCompanies} // sent to value
                    newSearchText={handleInputChangeSelectorCompanies}
                    name='company'
                    disabled={(!isNewData && !editMode && !placeId) || selectedAccess.role === 'contractor'}
                    hasError={companyError}
                    isMulti
                  />
                </FormControl>
              }
              {(selectedAccess.role === 'contractor' && !isNewData) && <Box>
                  <Typography variant='subtitle2' sx={{opacity: 0.6, fontWeight: 400, lineHeight: '1.4375em'}}>{i18n.t('autocompleteFormEquip.company')}</Typography>
                  {selectedCompanies.map((company) => <Chip
                    key={company.value}
                    label={company.label}
                    sx={{ marginTop: '5px', cursor:'default', marginLeft: '5px'}}/>
                  )}
                </Box>
              }
              <FormControl variant="standard" style={{ width: '45%' }}>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode && !placeId}
                  label={i18n.t('textFieldFormEquip.serialNumber')}
                  name='serialNumber'
                  onChange={event => { setSerialNumberError(false); setSerialNumber(event.target.value) }}
                  value={serialNumber}
                  margin='normal'
                  error={serialNumberError} />
              </FormControl>

              <FormControl variant="standard" style={{ width: '50%', marginLeft: '5%' }}>
              <DatePicker
                label='Data de Fabricação'
                margin='normal'
                onChange={date => { setManufacturingDateError(false); setManufacturingDate(date) }}
                value={manufacturingDate && new Date(manufacturingDate)}
                maxDate={new Date()}
                format="dd/MM/yyyy"
                disabled={!isNewData && !editMode && !placeId}
                error={manufacturingDateError}
                slotProps={{ textField: { variant: 'standard', } }}
              />
              </FormControl>

              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode && !placeId}
                  label={i18n.t('textFieldFormEquip.brand')}
                  name='brand'
                  onChange={event => { setBrandError(false); return setBrand(event.target.value.toUpperCase()) }}
                  value={brand}
                  error={brandError}
                  margin='normal' />
              </FormControl>

              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode && !placeId}
                  label={i18n.t('textFieldFormEquip.name')}
                  name='nome'
                  onChange={event => { setDescriptionError(false); return setDescription(event.target.value.toUpperCase()) }}
                  value={description}
                  error={descriptionError}
                  margin='normal' />
              </FormControl>

              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  disabled={!isNewData && !editMode && !placeId}
                  label={i18n.t('textFieldFormEquip.reference')}
                  name='referencia'
                  onChange={event => { setReferenceError(false); return setReference(event.target.value.toUpperCase()) }}
                  value={reference}
                  error={referenceError}
                  margin='normal' />
              </FormControl>
            </>
            {(isNewData || placeId) &&
              <DivSubmitButtons>
                <IconButton onClick={props.history.goBack} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
                <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
              </DivSubmitButtons>}
          </FormStyled>
        </Paper>
      </Container>
    </div>
  </>;
}

export default FormEquipments;

const styles = {
  arrowBack: {
    position: 'fixed',
    marginTop: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 195,
    height: 195,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  restoreButton: {
    backgroundColor: 'red',
    color: 'white',
    padding: '8px',
    margin: '7px 0px',
  },
  photoQRContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  photoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
  iconQrCode: {
    width: 30,
  },
  companiesTypography: {
    color: "rgba(0, 0, 0, 0.6)",
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.4375em",
    letterSpacing: "0.00938em",
  }
}
